import React from 'react';
export const SectionContext = React.createContext<{ pageIndex: number }>({ pageIndex: 0 });
